// extracted by mini-css-extract-plugin
module.exports = {"root":"_2dBWO","rotate":"Mp-QU","center":"_1iGjs","rotateOnCenter":"Vmmks"};